import { useEffect, useState } from "react";
import { announementsData } from "../../assets/announcements";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BUTTON_STYLE,
  INPUT_STYLE,
} from "../../assets/constants";
export default function ViewAnnounement() {
  const [announcement, setAnnouncement] = useState(null);
  const [comment, setComment] = useState(null);

  
  const location = useLocation();
  const { state } = location;
  console.log(state);

  const [errorMessage, setErrorMessage] = useState({
    commentError: null,
    generalError: null,
  });

  useEffect(() => {
    const data = announementsData.filter(
      (data, index) => data._id === state.id
    )[0];
    console.log(data);
    setAnnouncement(data);
  }, [state]);
  const user = JSON.parse(localStorage.getItem("user"));

  const handleSubmit = () => {
    const newComment = {
      studentID: "STD_234",
      studentName: "Emily",
      comment: comment,
      date: new Date(),
    };
    setAnnouncement((prevState) => {
      const updatedComments = [...prevState.comments, newComment];
      return { ...prevState, comments: updatedComments };
    });
  };
  return (
    <>
      <div className="space-y-4 ">
        <h1 className="font-medium text-2xl">Announcement Discussion</h1>
        <div className="w-full bg-white ">
          <div className="border-2 rounded-lg p-2 px-4">
            <div className="mb-5">
              <h1 className="text-3xl font-semibold py-1 ">
                {announcement?.title}
              </h1>
            </div>
            <div>
              <p className="text-lg font-medium uppercase mb-5">Discussion</p>
              {announcement?.comments?.map((comment, index) => {
                return (
                  <div className="flex flex-row space-x-3 items-start ">
                    <img
                      src={`https://api.dicebear.com/6.x/identicon/svg?seed=${comment?.studentName}`}
                      alt="avatar"
                      className="w-10 h-10 rounded-full border-[2px] border-gray-500 mt-2"
                    />
                    {/* <p className=" p-1 text-sm font-medium text-gray-600">{comment.date}</p> */}

                    <div
                      key={index}
                      className="bg-gray-50 w-full my-2 px-2 rounded-lg border-2 mb-5 select-none"
                    >
                      <h3 className="font-medium ">{comment?.studentName}</h3>

                      <p className=" py-2">{comment.comment}</p>
                    </div>
                  </div>
                );
              })}
              <div className="bg-gray-50 my-2 px-2 rounded-lg border-2 mb-5 select-none">
                <h3 className="font-medium ">{}</h3>

                <div className="mx-10 py-2">
                  <div className="relative">
                    <textarea
                      rows={5}
                      id="floating_comment"
                      placeholder="write something here..."
                      value={comment}
                      className={`${INPUT_STYLE} font-normal ${
                        errorMessage.commentError &&
                        "border-red-600 text-red-600"
                      }`}
                      onChange={(e) => setComment(e.target.value)}
                      onBlur={() => {
                        !comment &&
                          setErrorMessage((prev) => ({
                            ...prev,
                            commentError: "required",
                          }));
                      }}
                      onClick={() => {
                        errorMessage.commentError &&
                          setErrorMessage((prev) => ({
                            ...prev,
                            commentError: null,
                          }));
                      }}
                    />
                  </div>
                  <p className="text-sm text-red-600 h-4">
                    {errorMessage.commentError}
                  </p>
                  <button
                    className={`${BUTTON_STYLE} my-2`}
                    onClick={handleSubmit}
                  >
                    Comment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
